import moment from 'moment';
import momentz from 'moment-timezone';

const USER_READABLE_TIMESTAMP_FORMAT = 'MMM DD, YYYY, h:mm a';
const USER_READABLE_SPACETIME_FORMAT = 'dddd, Do, h:mm a';
const USER_READABLE_SPACETIME_DAY_FORMAT = 'dddd, Do';
const USER_READABLE_DAY_FORMAT = 'MMM DD, YYYY';
const LOCAL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const LOCAL_DATE_FORMAT_HUMAN = 'YYYY-MM-DD, h:mm a';
const ISO_ZONED_TIMESTAMP_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

export const isoTimestampNow = () => {
  const ts = momentz();
  return isoTimestamp(ts);
}

export const isoTimestamp = ts => {
  return momentz(ts, moment.ISO_8601).format(ISO_ZONED_TIMESTAMP_FORMAT);
}

export const localizedPickerTimestamp = (ts) => {
  if (ts) {
    return momentz(ts, moment.ISO_8601).format(LOCAL_DATE_FORMAT);
  }

  return null;
};

export const localizedTimestamp = (ts, timezone) => {
  if (ts) {
    const mom = momentz(ts, moment.ISO_8601);
    let momz;

    if (timezone) {
      momz = mom.tz(timezone);
    } else {
      momz = mom;
    }

    return momz.format(LOCAL_DATE_FORMAT);
  }

  return null;
};


export const formattedDate = date =>
  momentz(date, moment.ISO_8601).format(USER_READABLE_TIMESTAMP_FORMAT);

export const formattedSpaceTimeDate = date =>
  momentz(date, moment.ISO_8601).format(USER_READABLE_SPACETIME_FORMAT);

export const formattedSpaceTimeDay = date =>
  momentz(date, moment.ISO_8601).format(USER_READABLE_SPACETIME_DAY_FORMAT);

export const formattedIsoDate = date =>
  date.format(ISO_DATE_FORMAT);

export const formattedShortDate = date =>
  momentz(date, moment.ISO_8601).format(USER_READABLE_TIMESTAMP_FORMAT);

export const formattedDay = date =>
  momentz(date, moment.ISO_8601).format(USER_READABLE_DAY_FORMAT);

// positive if first comes after second
export const hoursBetweenMoments = (momentFirst, momentSecond) => momentSecond.diff(momentFirst, 'hour');

export const hoursBetweenTimestamps = (first, second) => {
  const momentFirst = moment(first, moment.ISO_8601);
  const momentSecond = moment(second, moment.ISO_8601);

  return momentSecond.diff(momentFirst, 'hour');
};


export default {
  formattedShortDate,
  formattedDate,
  formattedIsoDate,
  formattedSpaceTimeDate,
  formattedSpaceTimeDay,
  formattedDay,
  localizedPickerTimestamp,
  localizedTimestamp,
  hoursBetweenTimestamps,
  hoursBetweenMoments,
};



// WEBPACK FOOTER //
// ./src/types/timestamp.js